import { ArtistContactsTableRowType } from '../types';

export const artistContactRows: ArtistContactsTableRowType[] = [
  { label: 'AGENT', accessor: 'agent' },
  { label: 'BUYER', accessor: 'buyer' },
  { label: 'MANAGER', accessor: 'manager' },
  { label: 'PRODUCT_MANAGER', accessor: 'productManager' },
  { label: 'PROJECT_LEAD', accessor: 'projectLead' },
  { label: 'COORDINATOR', accessor: 'coordinator' },
];
